import { BREB_ROUTING_CODE_TYPE_HANDLE } from '@/shared/breb/constants/brebCommon.constant';

type BrebRoutingAlias = {
  routingCodeValue1?: string;
  routingCodeValue2?: string;
};

type BrebRailContact = {
  routingCodeType1?: string;
};

/**
 * Resuelve el alias legible de un beneficiario Bre-B para consultar el lookup de
 * la llave. El contrato guarda el alias en `routingCodeValue2` (BREB_ALIAS); los
 * contactos previos a ese contrato lo tienen en `routingCodeValue1`, de ahí el
 * fallback. Usa `||` y no `??` porque el backend modela la ausencia de valor como
 * cadena vacía, no `undefined`.
 *
 * @param contact - Beneficiario con los códigos de enrutamiento Bre-B.
 * @returns El alias legible, o `undefined` si ninguno está presente.
 */
export function resolveBrebAliasValue(
  contact: BrebRoutingAlias | null | undefined
): string | undefined {
  return contact?.routingCodeValue2 || contact?.routingCodeValue1 || undefined;
}

/**
 * Identifica un contacto o beneficiario del riel Bre-B por su `routingCodeType1`.
 * @param contact - Contacto o beneficiario con su código de enrutamiento.
 * @returns `true` si el contacto pertenece al riel Bre-B.
 */
export function isBrebContact(contact: BrebRailContact): boolean {
  return contact.routingCodeType1 === BREB_ROUTING_CODE_TYPE_HANDLE;
}
